export default __webpack_public_path__ + "static/media/NCS_CC_logo.2ab87dbc.png";